// [DS-MIGRATION] legacy Breadcrumbs - replaced by DS-backed Breadcrumb. Remove in follow-up PR.
// import Breadcrumbs from '@/componentsDS/Breadcrumbs/index.jsx';
import Breadcrumb from '@/dsComponents/Breadcrumb';
import useDataSchemaVersioning from '@/hooks/use-data-schema-versioning/index';
import usePage from '@/hooks/use-page';
import { useNavigate, useParams } from '@/lib/router-dom';
import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import VersionComparison from './components/compare/VersionComparison';

const DSVComparePage = () => {
	const { goTo, replace } = useNavigate();
	const { dataElementId } = useParams();
	const { loading, versionHistory, fetchAllVersions } = useDataSchemaVersioning();

	const elementName = versionHistory?.[0]?.elementName || 'Data Element';
	const { breadcrumbsItems } = usePage({
		title: `Compare — ${elementName}`,
		breadcrumbs: [
			{ label: '', link: '/' },
			{ label: 'Data Element', link: '/dsv' },
			{ label: elementName, link: `/dsv/${dataElementId}` },
			{ label: 'Compare Versions', link: '' },
		],
	});

	useEffect(() => {
		if (dataElementId) fetchAllVersions(dataElementId);
	}, [dataElementId]); // eslint-disable-line react-hooks/exhaustive-deps

	const params = new URLSearchParams(window.location.search);
	const baseParam = params.get('base') || undefined;
	const targetParam = params.get('target') || undefined;

	function handleSelectionChange({ base, target }) {
		if (!base || !target) return;
		replace(`/dsv/${dataElementId}/compare?base=${encodeURIComponent(base)}&target=${encodeURIComponent(target)}`);
	}

	function handleBackToElement() {
		goTo(`/dsv/${dataElementId}`);
	}

	const enoughVersions = Array.isArray(versionHistory) && versionHistory.length >= 2;

	return (
		<>
			{/* [DS-MIGRATION] legacy Breadcrumbs - replaced by DS-backed Breadcrumb. Remove in follow-up PR. */}
			{/* <Breadcrumbs breadcrumbItems={breadcrumbsItems} /> */}
			<Breadcrumb items={breadcrumbsItems} />
			<div
				className="dsv-detail__back"
				role="button"
				tabIndex={0}
				onClick={handleBackToElement}
				onKeyDown={(e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						handleBackToElement();
					}
				}}
			>
				<span className="dsv-detail__back-arrow">&larr;</span>
				<span>Back to Data Element</span>
			</div>

			<h1 className="dsv-detail__title">Compare Versions</h1>

			{enoughVersions ? (
				<VersionComparison
					versions={versionHistory}
					initialBase={baseParam}
					initialTarget={targetParam}
					onSelectionChange={handleSelectionChange}
				/>
			) : (
				<div className="dsv-compare__empty">Need at least two versions to compare.</div>
			)}

			{loading &&
				ReactDOM.createPortal(
					<div className="modal white">
						<div className="loading">
							<img src="/img/loading.gif" alt="loading" />
						</div>
					</div>,
					document.body,
				)}
		</>
	);
};

export default DSVComparePage;
